import React from 'react';
import { Title, Wrapper } from './styled';

const Banner = () => (
  <Wrapper data-cy="top-banner">
    <Title>SPECIAL SALE SS20 + FREE EXPRESS SHIPPING</Title>
  </Wrapper>
);

export default Banner;
